import gql from 'graphql-tag';

export default gql`
  mutation insertDesignProfile($object: design_profiles_insert_input!) {
    insert_design_profiles_one(object: $object) { profile_id }
  }
`;
